import { useMemo } from "react";

export function useCollectionKeys<T>(collection: T[], prefix: string = ''): string[] {
  const keys = useMemo(() => {
    const idSeed = (new Date()).getTime();
    const k = collection.map((_, i) => `${prefix}${(idSeed + i)}`);
    return k;
  }, [prefix, collection]);

  return keys;
}